module.exports = __webpack_public_path__ + "img/bootstrap-stack.f476a70e.png";